/**
 * Http methods definition according to https://developer.mozilla.org/en-US/docs/Web/HTTP/Methods
 */
export enum HttpMethod {
    GET = "GET",
    HEAD = "HEAD",
    POST = "POST",
    PUT = "PUT",
    DELETE = "DELETE",
    CONNECT = "CONNECT",
    OPTIONS = "OPTIONS",
    TRACE = "TRACE",
    PATCH = "PATCH",
}

export const AUTH_TOKEN = "authToken" as const;
